export default {
	backendUrl: 'http://localhost:4000',
	centrifugoWsUrl: 'ws://localhost:8000/connection/websocket',
	// aiWorkerUrl: 'https://ai-worker.edunexus.app',
	aiWorkerUrl: 'http://localhost:8787',
	otpLogin: true,
	razorpayEnv: 'TEST',
	qzCertificate: '',
	googleMapsApiKey: 'AIzaSyAXREi5qJis5osnHmQPXfs_285B2DciLPU',
};
